import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query awards($tenantId: ID!, $suggestionsListId: ID!) {
    awards(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
